<template>
  <v-form @input="$emit('validation', $event)">
    <v-select v-model="response.businessUnit" :items="businessUnits" :rules="requiredRules" label="Service Line" placeholder="Select service line" @input="emitValue" outline />

    <v-radio-group class="mt-0" v-model="response.salesOrRevenue" :rules="requiredRules" label="Target use of the cohort" @change="emitValue">
      <v-radio :label="item.label" :value="item.value" v-for="item in salesOrRevenueOptions" :key="item.label" />
    </v-radio-group>
    <v-text-field v-model="response.salesOrRevenueData.client" :rules="requiredRules" label="Client details/name" @input="emitValue" outline />
    <v-text-field v-model="response.salesOrRevenueData.project" :rules="requiredRules" label="Project" @input="emitValue" outline />
    <v-text-field v-model="response.salesOrRevenueData.linkToSFDC" :rules="requiredRules" label="A link to SFDC" @input="emitValue" outline />
    <v-select
      v-model="response.salesOrRevenueData.businessUnitInvolved"
      :items="extendedBusinessUnits"
      :rules="requiredArrayRules"
      label="Name of Service Lines Involved in delivery"
      placeholder="Select service lines"
      multiple
      chips
      deletableChips
      outline
    />
  </v-form>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      response: {
        businessUnit: null,
        salesOrRevenueData: {},
        ...this.value,
      },
      salesOrRevenueOptions: [{
        label: 'Sales Pitch/BD',
        value: true
      },
      {
        label: 'Revenue attached project delivery',
        value: false
      }],
      businessUnits: [
        'Patient Services',
        'Intouch',
        'Global Pricing',
        'Field Solutions',
        'EMC',
        'Data & Analytics'
      ],
      reasons: [
        'Project scoping',
        'RWD exploration',
        'Project deliverable',
        'Demo - Internal',
        'Demo - External client',
        'Other (Specify Below)',
      ],
      requiredRules: [v => !!v || v === false || 'Field is required'],
      requiredArrayRules: [v => (v || []).any() || 'Field is required'],
    };
  },
  computed: {
    extendedBusinessUnits() {
      return [
        ...this.businessUnits,
        'Complete Commercialization/Integrated Deal',
      ];
    },
  },
  methods: {
    emitValue() {
      this.$emit('input', this.response);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCreateCohortQuestionaire'] = this;
  }
}
</script>